import { inject, Pipe, PipeTransform } from '@angular/core';
import { VouchersStore } from '../../../vouchers/core/stores/VouchersStore';
import { CartItemTypes } from '../enums/CartItemTypes';
import { ICartItem } from '../interfaces/ICartItem';

@Pipe({
  name: 'isVoucherStackable',
  standalone: true
})
export class IsVoucherStackablePipe implements PipeTransform {
  private readonly _vouchersStore = inject(VouchersStore);

  public transform(item: ICartItem): boolean {
    if (item.itemType !== CartItemTypes.Voucher) {
      return false;
    }
    const voucherType = this._vouchersStore.voucherTypes().find(v => v.voucherTypeId === item.itemId);
    return voucherType ? !voucherType.flagVariable && !voucherType.isSeries : false;
  }
}
